import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import { motion } from "motion/react";
import { useEffect, useRef } from "react";

import { Input } from "./getInputs";
import { RVORechnerExplanationButton } from "./RVORechnerExplanationButton";

interface RVORechnerQuestionCardProps {
  input: Input;
  isActive: boolean;
}

export const RVORechnerQuestionCard = ({
  input,
  isActive,
}: RVORechnerQuestionCardProps) => {
  const divRef = useRef<HTMLDivElement>(null);

  const scrollToElement = () => {
    const { current } = divRef;

    if (current !== null) {
      current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  useEffect(() => {
    if (isActive) {
      scrollToElement();
    }
  }, [isActive]);

  return (
    <Box ref={divRef}>
      <Card
        component={motion.div}
        initial={{ x: -100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        key={input.title}
        sx={{
          boxShadow: "none",
          backgroundColor: (th) => th.palette.secondary.light,
          borderColor: (th) => th.palette.text.primary,
          position: "relative",
          borderRadius: 0,
        }}
      >
        <CardContent>
          <Stack
            sx={{
              gap: 2,
            }}
          >
            {input.pretitle && (
              <Typography
                variant="caption"
                sx={{
                  color: (th) => th.palette.text.secondary,
                }}
              >
                {input.pretitle}
              </Typography>
            )}

            <Typography variant="body1" sx={{ fontWeight: 600 }}>
              {input.title}
            </Typography>

            {input.input}
          </Stack>
        </CardContent>

        {input.explanation && (
          <RVORechnerExplanationButton
            title={`${input.pretitle} - ${input.title}`}
            explanation={input.explanation}
          />
        )}
      </Card>
    </Box>
  );
};
